import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";
import "datatables.net-dt";
import "datatables.net-dt/css/dataTables.dataTables.css";

function Addappointments() {
    const [staff, setStaff] = useState("");
    const [clientName, setClientName] = useState("");
    const [clientType, setClientType] = useState("");
    const [appointmentDate, setAppointmentDate] = useState("");
    const [timeFrom, setTimeFrom] = useState("");
    const [timeTo, setTimeTo] = useState("");
    const [staffList, setStaffList] = useState([]);
    const [clientList, setClientList] = useState([]);
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const [staffName, setStaffName] = useState("");
    const username = localStorage.getItem("username");
    const [clientId, setClientId] = useState("");
    const [overrideAssignment, setOverrideAssignment] = useState(false);
    let navigate = useNavigate();       

    const handleSubmit = (event) => {
        event.preventDefault();

        const data = { 
            staff_id: staff,
            staff_name: staffName,
            client_type: clientType,
            client_id: clientId,
            client_name: clientName,
            appointment_date: appointmentDate,
            time_from: timeFrom,
            time_to: timeTo,
            userid: accessuserid,
            assigned_userid: accessuserid,
            assigned_staffname: username,
            is_override: overrideAssignment
        };

        fetch(baseurladdress + "appointment/addappointment", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.status === "Success") {
                    Swal.fire({       
                        toast: true,
                        position: "top-end",
                        icon: "success",
                        title: "Appointment added successfully",
                        showConfirmButton: false,
                        timer: 1800,
                    });
                    navigate("/appointments");
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Failed",
                        text: result.message || "Unable to add appointment",
                    });
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Server Error",
                    text: error.message,
                });
            });
    };

    useEffect(() => {
        const GetAllStaff = () => {
            axios
                .get(baseurladdress + "staff/findallstaff", {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success") {
                        const options = res.data.staff.map((item) => (
                            <option key={item.staff_id} value={item.staff_id}>
                                {item.staff_name}
                            </option>
                        ));
                        setStaffList(options);
                    } else {
                        setStaffList([]);
                    }
                })
                .catch((err) => {
                    console.error(err);
                    alert("Failed to load staff list");
                });
        };

        GetAllStaff();
    }, []);

    useEffect(() => {
        // Reset client list and selections when staff or client type changes
        setClientList([]);
        setClientId("");
        setClientName("");
        
        // Exit early if no staff selected or client type not chosen
        if (!staff || clientType === "") {
            return;
        }

        // If client type is Doctor (0)  
        if (clientType === 0) {
            const GetDoctorsByStaff = () => {
                // If override is enabled, get all doctors; otherwise get only assigned doctors
                const endpoint = overrideAssignment
                    ? `${baseurladdress}doctors/findalldoctors`
                    : `${baseurladdress}appointment/bystaff/${staff}`;

                axios
                    .get(endpoint, {
                        headers: { Authorization: `Bearer ${accesstoken}` },
                    })
                    .then((res) => {
                        if (res.data.status === "Success") {
                            const options = res.data.doctors.map((item) => (
                                <option key={item.doctor_id} value={item.doctor_id}>
                                    {item.doctor_name}
                                </option>
                            ));
                            setClientList(options);
                        } else {
                            setClientList([]);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        setClientList([]);
                    });
            };

            GetDoctorsByStaff();
        }

        // If client type is Hospital (1)
        else if (clientType === 1) {
            const GetHospitalsByStaff = () => {
                // If override is enabled, get all hospitals; otherwise get only assigned hospitals
                const endpoint = overrideAssignment
                    ? `${baseurladdress}hospital/findallhospitals`
                    : `${baseurladdress}appointment/hospitalbystaff/${staff}`;

                axios
                    .get(endpoint, {
                        headers: { Authorization: `Bearer ${accesstoken}` },
                    })
                    .then((res) => {
                        if (res.data.status === "Success") {
                            const options = res.data.hospitals.map((item) => (
                                <option key={item.hosp_id} value={item.hosp_id}>
                                    {item.hosp_name}
                                </option>
                            ));
                            setClientList(options);
                        } else {
                            setClientList([]);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        setClientList([]);
                    });
            };

            GetHospitalsByStaff();
        }
        // If client type is Clinic (2)
        else if (clientType === 2) {
            const GetClinicsByStaff = () => {
                // If override is enabled, get all clinics; otherwise get only assigned clinics
                const endpoint = overrideAssignment
                    ? `${baseurladdress}clinic/findallclinics`
                    : `${baseurladdress}appointment/clinicbystaff/${staff}`;

                axios
                    .get(endpoint, {
                        headers: { Authorization: `Bearer ${accesstoken}` },
                    })
                    .then((res) => {
                        if (res.data.status === "Success") {
                            const options = res.data.clinics.map((item) => (
                                <option key={item.clinic_id} value={item.clinic_id}>
                                    {item.clinic_name}
                                </option>
                            ));
                            setClientList(options);
                        } else {
                            setClientList([]);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        setClientList([]);
                    });
            };

            GetClinicsByStaff();
        }
    }, [clientType, staff, overrideAssignment]);

    const handleOverrideChange = (e) => {
        const isChecked = e.target.checked;
        console.log("Override checkbox changed to:", isChecked); // Debug log
        setOverrideAssignment(isChecked);
        // Reset client selection when toggling override
        setClientId("");
        setClientName("");
        // Force client list to clear and refetch
        setClientList([]);
    };

    const getClientTypeName = () => {
        switch (clientType) {
            case 0: return "doctors";
            case 1: return "hospitals";
            case 2: return "clinics";
            default: return "clients";
        }
    };

    return (
        <div className="staff-page">
            <div className="staff-container">
                <div className="staff-header">
                    <NavLink to="/appointments">
                        <div className="float">
                            <i className="fa fa-arrow-left my-float"></i>
                        </div>
                    </NavLink>
                </div>

                <form onSubmit={handleSubmit} className="staff-form">
                    <div className="staff-columns">

                        {/* LEFT COLUMN */}
                        <div className="staff-column">
                            <div className="staff-card">
                                <div className="staff-card-body">

                                    <div className="card-header">
                                        <h4 className="card-title">ADD APPOINTMENT</h4>
                                        <div className="staff-heading-divider"></div>
                                    </div>

                                    <div className="staff-fields">

                                        <div className="staff-group">
                                            <label>Staff <span className="staff-required">*</span></label>
                                            <select
                                                onChange={(e) => {
                                                    setStaff(e.target.value);
                                                    setStaffName(e.target.options[e.target.selectedIndex].text);
                                                }}
                                                required
                                            >
                                                <option value="" disabled selected>Select</option>
                                                {staffList}
                                            </select>
                                        </div>

                                        <div className="staff-group">
                                            <label>
                                                Client Type <span className="staff-required">*</span>
                                            </label>
                                            <select
                                                value={clientType}
                                                onChange={(e) => {
                                                    setClientType(Number(e.target.value));
                                                    setClientId("");
                                                    setClientName("");
                                                }}
                                                required
                                                disabled={!staff}
                                            >
                                                <option value="" disabled>Select</option>
                                                <option value={2}>Clinics</option>
                                                <option value={1}>Hospital</option>
                                                <option value={0}>Doctor</option>
                                            </select>
                                        </div>

                                        {/* Override Checkbox - Show for all client types */}
                                        {(clientType === 0 || clientType === 1 || clientType === 2) && (
                                            <div className="staff-group">
                                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={overrideAssignment}
                                                        onChange={handleOverrideChange}
                                                        style={{ width: 'auto', cursor: 'pointer' }}
                                                    />
                                                    <span>Emergency assignment (Show all {getClientTypeName()})</span>
                                                </label>
                                                {overrideAssignment && (
                                                    <small style={{ color: '#ff9800', display: 'block', marginTop: '4px' }}>
                                                        ⚠️ Emergency/Special case - All {getClientTypeName()} are now available
                                                    </small>
                                                )}
                                            </div>
                                        )}

                                        <div className="staff-group">
                                            <label>
                                                Client Name <span className="staff-required">*</span>
                                            </label>
                                            <select
                                                value={clientId}
                                                onChange={(e) => {
                                                    setClientId(e.target.value);
                                                    setClientName(e.target.options[e.target.selectedIndex].text);
                                                }}
                                                required
                                                disabled={clientType === "" || clientType === null}
                                            >
                                                <option value="" disabled>Select</option>
                                                {clientList}
                                            </select>
                                        </div>

                                        <div className="staff-group">
                                            <label>Appointment Date <span className="staff-required">*</span></label>
                                            <input
                                                type="date"
                                                onChange={(e) => setAppointmentDate(e.target.value)}
                                                required
                                            />
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN */}
                        <div className="staff-column">
                            <div className="staff-card">
                                <div className="staff-card-body">

                                    <div className="staff-fields">
                                        <div className="staff-group">
                                            <label>Time From <span className="staff-required">*</span></label>
                                            <input
                                                type="time"
                                                onChange={(e) => setTimeFrom(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Time To <span className="staff-required">*</span></label>
                                            <input
                                                type="time"
                                                onChange={(e) => setTimeTo(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="staff-btn-container">
                        <button type="submit" className="staff-btn">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default Addappointments;